
export const CHECKOUT_URL = 'https://deco-emprende.impultienda.ar/checkout/deco-flores'

export const BRAND = {
  name: 'Deco Emprende',
  product: 'Deco Flores',
  subtitle: 'Guía Completa de Prensado y Manualidades Botánicas',
  logo: 'https://cdn.magicpatterns.com/uploads/3htjHFW9hH2bn6exXMmU3L/LOGO_DECOEMPRENDE.png',
  ebookMockup:
    'https://cdn.magicpatterns.com/uploads/jx3TsnMQKdi5bY9FboFDx3/MOCK_UP_DECO_FLORES.png',
}

export const TRUST_POINTS = [
  '50+ páginas · 9 métodos de prensado',
  'Sin experiencia previa necesaria',
  'Con flores de tu propio jardín',
  '10 proyectos paso a paso',
]

export const COUNTDOWN = [
  { value: '00', label: 'Horas' },
  { value: '30', label: 'Min' },
  { value: '00', label: 'Seg' },
]

export const offerIncludes: string[] = [
  'Guía digital paso a paso para aprender desde cero',
  '9 métodos de prensado explicados uno por uno',
  '10 proyectos botánicos: cuadros, tarjetas y regalos personalizados',
  'Bonus Resina Botánica: dijes, adornos y objetos decorativos',
  'Bonus Bordado Botánico: piezas delicadas con flores reales',
  'Guía para armar tu prensa casera + 3 recursos más',
  'Acceso inmediato y de por vida, desde cualquier dispositivo',
]
